export const GET_PRODUCT_ASSURANCE :string = "/ProductAssurance";
export const GET_PRODUCT_PROPERTIES :string = "/ProductProperties";
export const GET_PRODUCT_CONDITIONS :string = "/ProductConditions";
export const REGISTER_PRODUCT :string = "/Product";
export const EDIT_PRODUCT :string = "/editProduct";

